import React from 'react';
import { Box, Typography, List, ListItem, ListItemButton, ListItemText } from '@mui/material';

function RegistrationsList({ registrations }) {
  return (
    <Box sx={{ mt: 6, width: '100%' }}>
      <Typography variant="h6">Seneste 10 Tidsregistreringer</Typography>
      <List>
        {registrations.map((registration) => (
          <ListItem key={registration.id}>
            <ListItemButton>
              <ListItemText
                primary={`Dato: ${registration.date}, Starttid: ${registration.start_time}, Sluttid: ${registration.end_time}`}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );
}

export default RegistrationsList;
